import Cookie from 'js-cookie';
import { ApolloLink, execute, makePromise } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';

if (!window.fetch) {
  import('unfetch').then(unfetch => {
    window.fetch = unfetch;
  });
}

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.error(
        `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${path}`
      )
    );
  }

  if (networkError) console.error(`[Network error]: ${networkError}`);
});
const authLink = new ApolloLink((operation, forward) => {
  let headers = {};
  const token = Cookie.get('auth_token');
  if (token) {
    headers['Authorization-Token'] = `bearer ${token}`;
  }

  headers['Content-Language'] = 'en';
  operation.setContext({ headers });

  return forward(operation);
});

const link = ApolloLink.from([
  errorLink,
  authLink,
  new HttpLink({ uri: process.env.VUE_APP_API_URL })
]);

export default {
  query ({ query, variables = {} } = {}) {
    return makePromise(execute(link, { query, variables })).then(response => {
      if (response.errors) {
        throw new Error(response.errors[0].message);
      }

      return response;
    });
  },
  mutate ({ mutation, variables = {} } = {}) {
    return makePromise(execute(link, { query: mutation, variables })).then(response => {
      if (response.errors) {
        throw new Error(response.errors[0].message);
      }

      return response;
    });
  }
};
